import React from 'react'

class Download extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
          <g fill="#1B66B3">
            <g>
              <g>
                <path
                  d="M20 11.25c.38 0 .693.282.743.648l.007.102v8c0 .38-.282.693-.648.743L20 20.75H2c-.38 0-.693-.282-.743-.648L1.25 20v-8c0-.414.336-.75.75-.75.38 0 .693.282.743.648L2.75 12v7.25h16.5V12c0-.38.282-.693.648-.743L20 11.25zm-9-10c.38 0 .693.282.743.648L11.75 2v11.054l1.665-1.664c.266-.266.683-.29.976-.073l.085.073c.266.266.29.683.072.976l-.072.085-2.91 2.91c-.137.159-.34.259-.566.259-.189 0-.36-.07-.493-.184L7.524 12.45c-.292-.293-.292-.768 0-1.061.267-.266.683-.29.977-.073l.084.073 1.665 1.664V2c0-.414.336-.75.75-.75z"
                  transform="translate(-1298.000000, -599.000000) translate(328.000000, 508.000000) translate(970.000000, 91.000000)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default Download
